import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useIsMobile, useTealium, useTrans } from '@next-nx/hooks'
import { MenuItemType, OffertaType } from '@next-nx/utils/types'
import { Button, WContainer } from '@next-nx/shared-ui/atoms'
import styles from './ProdottiSearch.module.sass'
import { ArrowRight } from '@next-nx/shared-ui/icons'
import { OffertaCard } from '@next-nx/shared-ui/molecules'
import { CATEGORIA_MOBILITA_SOSTENIBILE_CODICE } from '@next-nx/utils/settings'
import { getTimestamp } from '@next-nx/utils'


interface Props {
  item: MenuItemType | undefined
  offerte: OffertaType[]
  className?: string
}


const ProdottiSearch = (props: Props) => {

  const { 
    item = undefined,
    offerte = [],
    className = '',
  } = props

  const t = useTrans()
  const isMobile = useIsMobile()

  const { linkDataLayer, getListingProdottiData } = useTealium()

  const handleTracking = () => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: "action",
      action_name: "items_view", 
      action_tech: "view",
      action_type: "carosello",
      action_timestamp,
      action_effect: "visualizzazione_prodotti",
      view_items: getListingProdottiData(offerte, "privati", "ricerca"),
    })
  }

  useEffect(() => {
    handleTracking()
  }, [])

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer variant="xs">
        <div className={styles.content}>
          <div className={styles.items}>
            {!!item.name && <p className={styles.title}>{item.name}</p>}
            <Swiper slidesPerView={1.1} spaceBetween={0} breakpoints={{
              576: {
                slidesPerView: 1.5
              },
              768: {
                slidesPerView: 2
              }
            }}>
              {offerte.map(x => (
                <SwiperSlide key={x.pk}>
                  <OffertaCard variant={isMobile ? "menu" : "horizontal"} offerta={x} showIi showIe azione='ricerca' />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          {!!item.url && !!item.ctaLabel && (
            <div className={styles.ctaBox}>
              <Button href={item.url} label={item.ctaLabel} variant="ghost" icon={<ArrowRight />} iconPos="right" />
            </div>
          )}
        </div>
      </WContainer>
    </div>
  ) : <></>
}

export default ProdottiSearch
